/**
 * SEARCH PAGE
 */
export const searchPageActionTypes = {
  FETCH_SEARCH_PAGE_DATA_START: "FETCH_SEARCH_PAGE_DATA_START",
  FETCH_SEARCH_PAGE_DATA_SUCCESS: "FETCH_SEARCH_PAGE_DATA_SUCCESS",
  FETCH_SEARCH_PAGE_DATA_ERROR: "FETCH_SEARCH_PAGE_DATA_ERROR",
  SET_SEARCH_RESULTS: "SET_SEARCH_RESULTS",
};
